import axiosInstance from "./axiosInstance";

export const setUserLanguage = async () => {
    try {
        const response = await axiosInstance.post(`/users/set_language/`, {
            token: localStorage.getItem("token")
        })

        return response.data
    } catch (error) {
        console.error('Failed to set user language:', error)
        return null;
    }
}
